import { render, staticRenderFns } from "./uploadPicTextMore2.vue?vue&type=template&id=484675f8&scoped=true"
import script from "./uploadPicTextMore2.vue?vue&type=script&lang=js"
export * from "./uploadPicTextMore2.vue?vue&type=script&lang=js"
import style0 from "./uploadPicTextMore2.vue?vue&type=style&index=0&id=484675f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484675f8",
  null
  
)

export default component.exports